import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RemoteFile } from '../../models/classes/remote_file.model';
import { AlertService } from '../../core/services/alert/alert.service';
import { ApiService } from '../../core/services/api/api.service';
import { ToastService } from '../../core/services/toast/toast.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'enfaf-remote-attachments',
    imports: [MatProgressSpinnerModule, MatButtonModule, MatIconModule],
    templateUrl: './enfaf-remote-attachments.component.html',
    styleUrl: './enfaf-remote-attachments.component.scss'
})
export class EnfafRemoteAttachmentsComponent implements OnInit {
  @Input() remoteAttachments: Array<RemoteFile> = [];
  @Input() isDeletingRemoteAttachment = false;
  @Input() showReplaceText = false;
  @Input() title = '';
  @Output() onDeleteRemoteAttachment = new EventEmitter();

  constructor(private alert: AlertService, private api: ApiService, private toast: ToastService) {}

  ngOnInit(): void {}

  async confirmRemoteAttachmentDeletion(attachment: RemoteFile, index: number): Promise<any> {
    const header = 'Borrar archivo';
    const message = '¿Estás seguro(a) de borrar este archivo? Esta acción no se podrá deshacer.';
    const notDelete = 'No borrar';
    const yesDelete = 'Borrar';
    const closeModal = await this.alert.presentConfirmActionAlert(header, message, notDelete, yesDelete);
    return closeModal ? this.deleteRemoteAttachment(attachment, index) : null;
  }

  async downloadRemoteAttachment(file: RemoteFile): Promise<void> {
    try {
      if (file.isDownloadingRemoteAttachment) return;
      file.isDownloadingRemoteAttachment = true;
      const result = await this.api.downloadRemoteAttachment(file.url);
      if (!result) {
        this.toast.presentErrorToast('Hubo un error descargando archivo');
      }
      file.isDownloadingRemoteAttachment = false;
    } catch (error: any) {
      file.isDownloadingRemoteAttachment = false;
      this.toast.presentErrorToast('Hubo un error descargando archivo');
    }
  }

  deleteRemoteAttachment(attachment: RemoteFile, index: number): void {
    const result = { attachment, index };
    this.onDeleteRemoteAttachment.emit(result);
  }
}
